export default "__VITE_ASSET__8c5e67d3__"